/* Landing Crema Antivárices: CTAs que abren Releasit, carga diferida de láminas y botón fijo. */
(function () {
  if (window.__avLanding) return;
  window.__avLanding = 1;

  function salta() {
    var b = document.querySelector('#_rsi-buy-now-button') || document.querySelector('[id*="rsi-buy-now"]');
    if (b) {
      b.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      return;
    }
    var t = document.querySelector('form[action*="/cart/add"]');
    if (!t) return;
    var y = t.getBoundingClientRect().top + window.pageYOffset - 120;
    var h = document.documentElement, prev = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    try { window.scrollTo({ top: y, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
    h.style.scrollBehavior = prev;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-av-jump]')) salta();
  });

  function ld(i) {
    if (i.dataset.avSrc) { i.src = i.dataset.avSrc; i.removeAttribute('data-av-src'); }
  }
  function lazy() {
    var l = [].slice.call(document.querySelectorAll('img[data-av-src]'));
    if (!('IntersectionObserver' in window)) { l.forEach(ld); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var s = e.target.closest('.av-testi');
        (s ? [].slice.call(s.querySelectorAll('img[data-av-src]')) : [e.target]).forEach(ld);
        io.unobserve(e.target);
      });
    }, { rootMargin: '1000px 0px' });
    l.forEach(function (i) { io.observe(i); });
  }

  function sticky() {
    var b = document.querySelector('[data-av-sticky]');
    if (!b) return;
    function f() {
      var r = document.querySelector('._rsi-buy-now-button-floating');
      b.classList.toggle('on', !r && window.pageYOffset > 700);
    }
    window.addEventListener('scroll', f, { passive: true });
    f();
  }

  function init() { lazy(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
